<template>
  <div class="collapse">
    <div
      class="hd"
      :class="{
        fold: !configMainShow['guide'],
      }"
      @click="configMainShow['guide'] = !configMainShow['guide']"
    >
      <div class="title-fix">
        <i class="fa-angle-down"></i>
        <span>定时引导</span>
        <span class="el-switch" @click.stop="toggleEnable('guide', '定时引导')">
          <el-switch v-model="configure.guide.enable" disabled></el-switch>
        </span>
      </div>
    </div>
    <div
      class="bd"
      @click="
        isNaN(featureList['guide'].timeRemaining)
          ? shoWDialogBuy(featureList['guide']['productKey'], '基础包', 'guide')
          : featureList['guide'].timeRemaining <= 0
          ? showFunctionalRenewal(true)
          : configure.guide.enable
          ? ''
          : toggleEnable('guide', '定时引导')
      "
      :class="{
        'no-buy': isNaN(featureList['guide'].timeRemaining),
        expired: featureList['guide'].timeRemaining <= 0,
        'shut-off': !configure.guide.enable,
      }"
    >
      <el-row>
        <el-col :span="5">发送模式</el-col>
        <el-col :span="19">
          <el-radio-group v-model="configure.guide.sendingMode" size="small">
            <el-radio-button label="queue">顺序发送</el-radio-button>
            <el-radio-button label="random">随机发送</el-radio-button>
          </el-radio-group>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">发送频率</el-col>
        <el-col :span="19">
          每隔
          <el-input-number
            v-model="configure.guide.timeInterval"
            :controls-position="isPC ? 'right' : ''"
            :min="0.1"
            :max="60"
            size="mini"
            :precision="1"
          ></el-input-number
          >分钟发送一条
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">概率设置</el-col>
        <el-col :span="19">
          <div class="block-tag">
            可根据自己的房间情况，设置不同的句式池的抽取概率。攒粉期主播推荐多引导订阅和分享，站起来的主播可以多引导消费
          </div>
          <div>
            综合引导-句式池：
            <el-input-number
              v-model="configure.guide.guideAll.chance"
              :controls-position="isPC ? 'right' : ''"
              :min="0"
              :max="100"
              size="mini"
              :precision="0"
            ></el-input-number
            >%出现概率
          </div>
          <div>
            订阅引导-句式池：
            <el-input-number
              v-model="configure.guide.guideFollow.chance"
              :controls-position="isPC ? 'right' : ''"
              :min="0"
              :max="100"
              size="mini"
              :precision="0"
            ></el-input-number
            >%出现概率
          </div>
          <div>
            消费引导-句式池：
            <el-input-number
              v-model="configure.guide.guideCost.chance"
              :controls-position="isPC ? 'right' : ''"
              :min="0"
              :max="100"
              size="mini"
              :precision="0"
            ></el-input-number
            >%出现概率
          </div>
          <div>
            分享引导-句式池：
            <el-input-number
              v-model="configure.guide.guideShare.chance"
              :controls-position="isPC ? 'right' : ''"
              :min="0"
              :max="100"
              size="mini"
              :precision="0"
            ></el-input-number
            >%出现概率
          </div>
        </el-col>
      </el-row>
      <div class="dash-line"></div>
      <el-row>
        <el-col :span="5">综合引导<br />句式池</el-col>
        <el-col :span="19">
          <div class="sentence-list">
            <div class="block-tag">
              随机发送下列句式，可以点击编辑或删除，也可自定义添加。
            </div>
            <ul>
              <li
                v-for="(item, index) in configure.guide.guideAll.tpl"
                :key="index"
              >
                <Editor
                  v-model="configure.guide.guideAll.tpl[index]"
                  @input="checkEmpty(configure.guide.guideAll.tpl, index)"
                  :labels="['anchorNick']"
                ></Editor>
                <i class="fa-window-close" @click="removeGuideAll(index)"></i>
              </li>
            </ul>
          </div>
          <div
            class="sentence-add"
            tabindex="99"
            @focusin="eleFocusIn('addGuideAll')"
            @focusout="singleInputFocusOut('addGuideAll')"
          >
            <Editor
              v-model.trim="addGuideAll"
              mode="edit"
              :labels="['anchorNick']"
            ></Editor>
            <el-popover
              ref="addGuideAll"
              placement="bottom-end"
              width="280"
              v-model="isShowInputBlurTips.addGuideAll"
              trigger="manual"
              :popper-options="{
                boundariesElement: 'body',
                adaptive: false,
              }"
            >
              <p>记得点“添加句子”才会生效哦</p>
            </el-popover>
            <el-button
              size="small"
              @click="addGuideAllTpl"
              v-popover:addGuideAll
              >添加句子</el-button
            >
          </div>
        </el-col>
      </el-row>
      <div class="dash-line"></div>
      <el-row>
        <el-col :span="5">订阅引导<br />句式池</el-col>
        <el-col :span="19">
          <div class="sentence-list">
            <div class="block-tag">
              随机发送下列句式，可以点击编辑或删除，也可自定义添加。
            </div>
            <ul>
              <li
                v-for="(item, index) in configure.guide.guideFollow.tpl"
                :key="index"
              >
                <Editor
                  v-model="configure.guide.guideFollow.tpl[index]"
                  @input="checkEmpty(configure.guide.guideFollow.tpl, index)"
                  :labels="['anchorNick']"
                ></Editor>
                <i
                  class="fa-window-close"
                  @click="removeGuideFollow(index)"
                ></i>
              </li>
            </ul>
          </div>
          <div
            class="sentence-add"
            tabindex="99"
            @focusin="eleFocusIn('addGuideFollow')"
            @focusout="singleInputFocusOut('addGuideFollow')"
          >
            <Editor
              v-model.trim="addGuideFollow"
              mode="edit"
              :labels="['anchorNick']"
            ></Editor>
            <el-popover
              ref="addGuideFollow"
              placement="bottom-end"
              width="280"
              v-model="isShowInputBlurTips.addGuideFollow"
              trigger="manual"
              :popper-options="{
                boundariesElement: 'body',
                adaptive: false,
              }"
            >
              <p>记得点“添加句子”才会生效哦</p>
            </el-popover>
            <el-button
              size="small"
              @click="addGuideFollowTpl"
              v-popover:addGuideFollow
              >添加句子</el-button
            >
          </div>
        </el-col>
      </el-row>
      <div class="dash-line"></div>
      <el-row>
        <el-col :span="5">消费引导<br />句式池</el-col>
        <el-col :span="19">
          <div class="sentence-list">
            <div class="block-tag">
              随机发送下列句式，可以点击编辑或删除，也可自定义添加。
            </div>
            <ul>
              <li
                v-for="(item, index) in configure.guide.guideCost.tpl"
                :key="index"
              >
                <Editor
                  v-model="configure.guide.guideCost.tpl[index]"
                  @input="checkEmpty(configure.guide.guideCost.tpl, index)"
                  :labels="['anchorNick']"
                ></Editor>
                <i class="fa-window-close" @click="removeGuideCost(index)"></i>
              </li>
            </ul>
          </div>
          <div
            class="sentence-add"
            tabindex="99"
            @focusin="eleFocusIn('addGuideCost')"
            @focusout="singleInputFocusOut('addGuideCost')"
          >
            <Editor
              v-model.trim="addGuideCost"
              mode="edit"
              :labels="['anchorNick']"
            ></Editor>
            <el-popover
              ref="addGuideCost"
              placement="bottom-end"
              width="280"
              v-model="isShowInputBlurTips.addGuideCost"
              trigger="manual"
              :popper-options="{
                boundariesElement: 'body',
                adaptive: false,
              }"
            >
              <p>记得点“添加句子”才会生效哦</p>
            </el-popover>
            <el-button
              size="small"
              @click="addGuideCostTpl"
              v-popover:addGuideCost
              >添加句子</el-button
            >
          </div>
        </el-col>
      </el-row>
      <div class="dash-line"></div>
      <el-row>
        <el-col :span="5">分享引导<br />句式池</el-col>
        <el-col :span="19">
          <div class="sentence-list">
            <div class="block-tag">
              随机发送下列句式，可以点击编辑或删除，也可自定义添加。
            </div>
            <ul>
              <li
                v-for="(item, index) in configure.guide.guideShare.tpl"
                :key="index"
              >
                <Editor
                  v-model="configure.guide.guideShare.tpl[index]"
                  @input="checkEmpty(configure.guide.guideShare.tpl, index)"
                  :labels="['anchorNick']"
                ></Editor>
                <i class="fa-window-close" @click="removeGuideShare(index)"></i>
              </li>
            </ul>
          </div>
          <div
            class="sentence-add"
            tabindex="99"
            @focusin="eleFocusIn('addGuideShare')"
            @focusout="singleInputFocusOut('addGuideShare')"
          >
            <Editor
              v-model.trim="addGuideShare"
              mode="edit"
              :labels="['anchorNick']"
            ></Editor>
            <el-popover
              ref="addGuideShare"
              placement="bottom-end"
              width="280"
              v-model="isShowInputBlurTips.addGuideShare"
              trigger="manual"
              :popper-options="{
                boundariesElement: 'body',
                adaptive: false,
              }"
            >
              <p>记得点“添加句子”才会生效哦</p>
            </el-popover>
            <el-button
              size="small"
              @click="addGuideShareTpl"
              v-popover:addGuideShare
              >添加句子</el-button
            >
          </div>
        </el-col>
      </el-row>
      <div class="reset-row">
        <el-button
          type="danger"
          size="small"
          @click="resetDefault('定时引导', 'guide')"
          >「定时引导」恢复默认</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { configCommon } from "@/mixins/configCommon";
import { commonFuc } from "@/mixins/commonFuc";
export default {
  mixins: [configCommon, commonFuc],
  data() {
    return {
      addGuideAll: "", // 定时引导 句式输入框
      addGuideFollow: "", // 订阅引动 句式输入框
      addGuideCost: "", // 消费引导 句式输入框
      addGuideShare: "", // 分享引导 句式输入框
    };
  },
  props: {
    configure: {
      type: Object,
      default: null,
    },
    featureList: {
      type: Object,
      default: null,
    },
    configMainShow: {
      type: Object,
      default: () => {
        return {
          account: true,
          welcome: true,
          giftTks: true,
          guide: true,
          autoReply: true,
          AIChat: true,
          readText: true,
          autoBan: true,
          keyPerson: true,
          begGift: true,
          guessNum: true,
          duty: true,
          global: true,
        };
      },
    },
  },
  mounted() {},
  methods: {
    removeGuideAll(index) {
      this.configure.guide.guideAll.tpl.splice(index, 1);
      this.$message.success("删除成功");
    }, //删除综合引导句式

    addGuideAllTpl() {
      if (this.addGuideAll == "") {
        this.$message.warning("不能为空哦");
      } else {
        this.configure.guide.guideAll.tpl.unshift(this.addGuideAll);
        this.addGuideAll = "";
        this.$message.success("添加成功");
      }
    }, // 综合引导句式添加
    removeGuideFollow(index) {
      this.configure.guide.guideFollow.tpl.splice(index, 1);
      this.$message.success("删除成功");
    }, //删除订阅引导句式
    addGuideFollowTpl() {
      if (this.addGuideFollow === "") {
        this.$message.warning("不能为空哦");
      } else {
        this.configure.guide.guideFollow.tpl.unshift(this.addGuideFollow);
        this.$message.success("添加成功");
        this.addGuideFollow = "";
      }
    }, // 订阅引导句式添加
    removeGuideCost(index) {
      this.configure.guide.guideCost.tpl.splice(index, 1);
      this.$message.success("删除成功");
    }, // 删除消费引导句式
    addGuideCostTpl() {
      if (this.addGuideCost === "") {
        this.$message.warning("不能为空哦");
      } else {
        this.configure.guide.guideCost.tpl.unshift(this.addGuideCost);
        this.$message.success("添加成功");
        this.addGuideCost = "";
      }
    }, // 消费引导句式添加
    removeGuideShare(index) {
      this.configure.guide.guideShare.tpl.splice(index, 1);
      this.$message.success("删除成功");
    }, // 删除分享引导句式
    addGuideShareTpl() {
      if (this.addGuideShare === "") {
        this.$message.warning("不能为空哦");
      } else {
        this.configure.guide.guideShare.tpl.unshift(this.addGuideShare);
        this.$message.success("添加成功");
        this.addGuideShare = "";
      }
    }, //  分享引导句式添加
  },
};
</script>
